import moment from "moment/moment";
//service
import { getHotel } from "../../../utils/services/hotel";

export const excelColumnsPtBr = {
  Participante: "login",
  Hotel: "hotel",
  "Data CheckIn": "checkindate",
  "Hora CheckIn": "checkintime",
  "Data CheckOut": "checkoutdate",
  "Hora CheckOut": "checkouttime",
  "Numero Da Reserva": "reservationnumber",
  Endereco: "address",
  "Telefone Do Hotel": "phonenumber",
  "Informacoes Extras": "extrainformation",
};

export const excelColumnsPtBrUpdate = {
  IdHotel: "id",
  Participante: "login",
  Hotel: "hotel",
  "Data CheckIn": "checkindate",
  "Hora CheckIn": "checkintime",
  "Data CheckOut": "checkoutdate",
  "Hora CheckOut": "checkouttime",
  "Numero Da Reserva": "reservationnumber",
  Endereco: "address",
  "Telefone Do Hotel": "phonenumber",
  "Informacoes Extras": "extrainformation",
};

export const excelColumnsPtBrDelete = {
  NomeParticipante: "name",
  IdHotel: "id",
};

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function formatDate(date) {
  try {
    const dateSplit = date.split("/");

    if (!dateSplit[0] || !dateSplit[1] || !dateSplit[2]) return undefined;

    const dateFormated = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

    if (new Date(dateFormated)) {
      return dateFormated;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    if (/^\d{2}:\d{2}$/.test(time) && moment(time, "HH:mm", true).isValid()) {
      return time;
    } else return undefined;
  } catch (error) {
    return undefined;
  }
}

function emailValidate(email) {
  try {
    const emailValid = regexEmail.test(email);
    return emailValid ? email : undefined;
  } catch (error) {
    return undefined;
  }
}

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    login: emailValidate(row.login),
    hotel: row.hotel,
    checkindate: formatDate(row.checkindate),
    checkoutdate: formatDate(row.checkoutdate),
    checkintime: formatTime(row.checkintime),
    checkouttime: formatTime(row.checkouttime),
    address: row.address,
    reservationnumber: row.reservationnumber ? row.reservationnumber : "",
    phonenumber: row.phonenumber ? row.phonenumber : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    login: emailValidate(row.login),
    hotel: row.hotel,
    checkindate: formatDate(row.checkindate),
    checkoutdate: formatDate(row.checkoutdate),
    checkintime: formatTime(row.checkintime),
    checkouttime: formatTime(row.checkouttime),
    address: row.address,
    reservationnumber: row.reservationnumber ? row.reservationnumber : "",
    phonenumber: row.phonenumber ? row.phonenumber : "",
    extrainformation: row.extrainformation ? row.extrainformation : "",
  };

  return formatedRow;
}

export async function getValidHotels(hotels, idEvent, isUpdate) {
  try {
    const res = await getHotel({
      idEvent: idEvent,
      offset: 1,
      limit: 10000,
      search: "",
      columnSearch: "login",
    });

    const listAllHotels =
      res.findOneHotelData.count > 0 ? res.findOneHotelData.data : [];

    var hotelsNotFounds = [];

    for (const hotel of hotels) {
      const search = listAllHotels.find((e) => e.id === hotel.id);

      if (!search) {
        hotelsNotFounds.push({
          ...hotel,
          id: undefined,
        });
      } else if (search && isUpdate && search.login.email !== hotel.login) {
        hotelsNotFounds.push({
          ...hotel,
          login: undefined,
        });
      } else {
      }
    }

    return hotelsNotFounds;
  } catch (error) {
    // console.log("get hotels error", error);
    return [];
  }
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    name: row.name,
  };

  return formatedRow;
}
